import { render } from "./goal-type.vue?vue&type=template&id=f72a2b6c"
import script from "./goal-type.vue?vue&type=script&lang=js"
export * from "./goal-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__